import React, { Component } from 'react'
import { Card } from 'antd'
import { IntegrationConsumer, IntegrationProvider } from '../../../../context/IntegrationContext'
import IntegrationListOnNetwork from './list'

export default class IntegrationListTab extends Component<{network_uuid}> {

  private integrationFilterDispatchOptions = {
    search: {
      deleted: false,
      active: true,
      branch: {
        with: {
          deleted: false
        }
      },
      shelter_id:"",
      partner_key:"SHELTER_BUDDY"
    },
    options: {
      sort: ['-last_sync'],
      _force_ids: true
    }
  } as const

  integrationListSearch = Object.assign({}, this.integrationFilterDispatchOptions)

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.integrationListSearch = {
        ...this.integrationListSearch,
        search: payload.search
      }
    }
  }


  render() {
    const { permissions, history  }: any = this.props
    return (
        <IntegrationProvider>
        <IntegrationConsumer>
            {({
                    fetching,
                    integrations,
                    pagination,
                    requestIntegrationList,
                    requestIntegrationNetworkListSimple
                  }) => {

                    return (
                      <>
            <Card title="List of Integrations">
                <IntegrationListOnNetwork
                loading={fetching}
                network_uuid={this.props.network_uuid}
                integrations={integrations}
                pagination={pagination}
                permissions={permissions}
                history={history}
                searchOptions={this.integrationListSearch}
                loadIntegrations={requestIntegrationList}
                requestIntegrationNetworkListSimple={requestIntegrationNetworkListSimple}
                />
            </Card>
                </>
            )
            }}
        </IntegrationConsumer>
        </IntegrationProvider>
    )
  }
}
